export default __webpack_public_path__ + "static/media/pic11.e20d3867.png";